// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3Wmzv","container":"styles_container__1hU0H","title":"styles_title__Nf2i1","wrapper":"styles_wrapper__2VrVr","answer":"styles_answer__2OUYR"};